import React from 'react'

import { useAnalysisType } from 'redux/hooks/AnalysisTypes'
import { useParams } from 'utils/hooks'

import AnalysesTable from 'components_new/organisms/analyses/AnalysesTable'

import AnalysisTemplate from 'components_new/templates/AnalysisTypeTemplate'

const AnalysisTypeAnalyses = () => {
  const { id } = useParams<{ id: string }>()

  const { analysisType } = useAnalysisType(id)

  if (!analysisType) return <></>

  return (
    <AnalysisTemplate
      content={{
        fullWidth: true
      }}
      variant="static"
    >
      <AnalysesTable analysisTypeId={id} sx={{ flex: 1 }} />
    </AnalysisTemplate>
  )
}

export default AnalysisTypeAnalyses
